<template>
  <div class="approved-feedback" :class="{ fallback: isFallback }">
    <AnimationCheck />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import UtilMixin from '@/mixins/util';
import AnimationCheck from '@/components/common/AnimationCheck.vue';

export default {
  name: 'checkout-approved-feedback',
  mixins: [UtilMixin],
  components: {
    AnimationCheck,
  },
  props: {
    isFallback: {
      type: Boolean,
    },
  },
  methods: {
    ...mapMutations('checkout', ['setApprovedTrue']),
    ...mapActions('checkout', [
      'goToPage',
    ]),
  },
  mounted() {
    setTimeout(() => {
      this.$emit('showApproved');
    }, 1800);
  },
};
</script>

<style lang="scss" scoped>
.approved-feedback {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 40%;
  @media (min-width: $lg) {
    margin-top: 30%;
  }

}
.fallback {
  @media (min-width: $lg) {
    position: relative;
    margin-top: 40%;
  }
}

.approved-feedback-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 15px;
}

.approved-feedback-title {
  @extend .h2;
  @extend .gray-600;
  margin-bottom: 8px;
  &.mobile {
    font-size: 20px;
    line-height: 24px;
  }
}

.approved-feedback-subtitle {
  @extend .body-regular;
  @extend .gray-400;
  &.mobile {
    font-size: 16px;
    line-height: 24px;
  }
}

</style>
